import { render, staticRenderFns } from "./gelenteklif.vue?vue&type=template&id=35c0f5f2"
import script from "./gelenteklif.vue?vue&type=script&lang=js"
export * from "./gelenteklif.vue?vue&type=script&lang=js"
import style0 from "./gelenteklif.vue?vue&type=style&index=0&id=35c0f5f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports